// extracted by mini-css-extract-plugin
module.exports = {"TaskOverview":"TaskOverview--4rB_T","Progress":"Progress--3IE3c"};